export default __webpack_public_path__ + "static/media/proxima_nova_bold.d82aec48.ttf";